<script setup lang="ts">
import { useToastStore } from "@/stores/toast"
import Toast from "./Toast.vue"

const toasts = useToastStore()
</script>

<template>
  <div class="fixed top-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
    <div v-for="t in toasts.toasts" :key="t.id" class="pointer-events-auto">
      <Toast :toast="t" @dismiss="toasts.dismiss" />
    </div>
  </div>
</template>
